import React from 'react';
import { BrowserRouter, Routes, Route, Link } from 'react-router-dom';
import './index.css';
import Home from './pages/Home';
import Servicios from './pages/Servicios';
import Nosotros from './pages/Nosotros';
import Contacto from './pages/Contacto';
import WhatsAppButton from './components/WhatsAppButton';
import Header from './components/Header';
import Footer from './components/Footer';

// Importar componentes individuales de servicios
import RevisionSistematica from './pages/services/RevisionSistematica_new';
import Proyecto from './pages/services/Proyecto_new';
import TesisDePregrado from './pages/services/TesisDePregrado';
import DatosEstadisticos from './pages/services/DatosEstadisticos';
import TesisDeMaestria from './pages/services/TesisDeMaestria';
import TrabajoSuficienciaProf from './pages/services/TrabajoSuficienciaProf';
import PlanesNegocio from './pages/services/PlanesNegocio';
import AnalisisExpedientes from './pages/services/AnalisisExpedientes';
import TrabajosCiclo from './pages/services/TrabajosCiclo';

const WHATSAPP_NUMBER = '+51983318651';

const SERVICES = [
  { name: 'Revisión Sistemática', price: 550, icon: 'doc', path: 'revision-sistematica', component: RevisionSistematica },
  { name: 'Proyecto', price: 700, icon: 'document', path: 'proyecto', component: Proyecto },
  { name: 'Tesis de Pregrado', price: 1500, icon: 'graduation', path: 'tesis-de-pregrado', component: TesisDePregrado },
  { name: 'Datos Estáticos', price: 300, icon: 'stats', path: 'datos-estadisticos', component: DatosEstadisticos },
  { name: 'Tesis de Maestría', price: 2600, icon: 'graduation', path: 'tesis-de-maestria', component: TesisDeMaestria },
  { name: 'Trabajo de Suficiencia Profesional', price: 1300, icon: 'document', path: 'trabajo-de-suficiencia-profesional', component: TrabajoSuficienciaProf },
  { name: 'Planes de Negocio', price: 2800, icon: 'briefcase', path: 'planes-de-negocio', component: PlanesNegocio },
  { name: 'Análisis de Expedientes', price: 900, icon: 'document', path: 'analisis-de-expedientes', component: AnalisisExpedientes },
  { name: 'Trabajos de Ciclo', price: 'Según estructura', icon: 'document', path: 'trabajos-de-ciclo', component: TrabajosCiclo },
];

function App() {
  return (
    <BrowserRouter>
      <div className="min-h-screen flex flex-col bg-white text-gray-900">
        <Header services={SERVICES} />
        <main className="flex-1 overflow-hidden">
          <Routes>
            <Route path="/" element={<Home services={SERVICES} />} />
            <Route path="/servicios" element={<Servicios services={SERVICES} />} />
            <Route path="/nosotros" element={<Nosotros />} />
            <Route path="/contacto" element={<Contacto />} />
            <Route path="/servicios/revision-sistematica" element={<RevisionSistematica />} />
            <Route path="/servicios/proyecto" element={<Proyecto />} />
            <Route path="/servicios/tesis-de-pregrado" element={<TesisDePregrado />} />
            <Route path="/servicios/datos-estadisticos" element={<DatosEstadisticos />} />
            <Route path="/servicios/tesis-de-maestria" element={<TesisDeMaestria />} />
            <Route path="/servicios/trabajo-de-suficiencia-profesional" element={<TrabajoSuficienciaProf />} />
            <Route path="/servicios/planes-de-negocio" element={<PlanesNegocio />} />
            <Route path="/servicios/analisis-de-expedientes" element={<AnalisisExpedientes />} />
            <Route path="/servicios/trabajos-de-ciclo" element={<TrabajosCiclo />} />
            <Route path="*" element={
              <div className="min-h-screen flex flex-col items-center justify-center bg-white px-4">
                <h1 className="text-6xl font-bold text-gray-900">404</h1>
                <p className="mt-4 text-xl text-gray-600">Página no encontrada</p>
                <p className="mt-2 text-gray-500 text-center max-w-md">La ruta que buscas no existe. Regresa al inicio para encontrar lo que necesitas.</p>
                <Link to="/" className="inline-flex mt-8 px-8 py-3.5 rounded-lg bg-gray-900 text-white font-semibold hover:bg-gray-800 transition">Volver al inicio</Link>
              </div>
            } />
          </Routes>
        </main>
        <Footer />
        <WhatsAppButton phone={WHATSAPP_NUMBER} />
      </div>
    </BrowserRouter>
  );
}

export default App;
